module.exports = __webpack_public_path__ + "static/media/TEFCGeneralPurpose.9001e173.pdf";